import React from 'react';
import PropTypes from 'prop-types';
import MuiSnackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

export const SNACKBAR_TYPES = {
  success: 'success',
  error: 'error',
};

export const PNSnackbar = ({ open, autoHideDuration, type, onClose, children }) => {
  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={autoHideDuration ? autoHideDuration : undefined}
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      onClose={onClose}>
      <Alert onClose={onClose} severity={type}>
        {children}
      </Alert>
    </MuiSnackbar>
  );
};

PNSnackbar.propTypes = {
  open: PropTypes.bool,
  autoHideDuration: PropTypes.number,
  type: PropTypes.oneOf(Object.keys(SNACKBAR_TYPES).map((key) => SNACKBAR_TYPES[key])),
  onClose: PropTypes.func,
};
